import {AppsyncService} from "../shared/AppsyncService";
import {oktaAuth} from "../config/OktaConfig";
import gql from "graphql-tag";
import {submitManualTantCorrection} from "../../graphql/ds-left-cw-api/tant/mutations";
import {findShipmentsById} from "../../graphql/ds-left-cw-api/shipments/queries"
import {Shipment} from "../../graphql/ds-left-cw-api/tant/api";

export class DSLeftCWService {

    tantAppsyncService : AppsyncService;
    shipmentAppsyncService : AppsyncService;

    constructor() {
        this.tantAppsyncService = new AppsyncService(process.env.REACT_APP_APPSYNC_TANT_ENDPOINT!, oktaAuth)
        this.shipmentAppsyncService = new AppsyncService(process.env.REACT_APP_APPSYNC_SHIPMENT_ENDPOINT!, oktaAuth)
    }

    async submitDSLeftCW(
        location: string,
        reason: string,
        comment: string,
        shipments: Shipment[]
        ): Promise<any> {
        return this.tantAppsyncService.appSyncClient.mutate({
            mutation: gql(submitManualTantCorrection), variables: {
                location: location,
                reason: reason,
                comment: comment,
                shipments: shipments
            }
        });
    }

    async findShipmentsById(
        shipmentIds: string[]
    ): Promise<any> {
        return this.shipmentAppsyncService.appSyncClient.query({
            query: gql(findShipmentsById),
            variables: { shipmentIds },
            fetchPolicy: "network-only"
        });
    }
}